import { ExternalIntegrationProvider } from "@bbj-types/externalIntegrations";

export const EXTERNAL_INTEGRATION_PROVIDERS_LABELS: Record<string, string> = {
  [ExternalIntegrationProvider.FT]: "France Travail",
  [ExternalIntegrationProvider.VIESION]: "Viesion",
  [ExternalIntegrationProvider.NEOLINK]: "Neolink",
};
